import React, { useEffect, useRef } from "react";
import { createPortal } from 'react-dom';
import styles from './Modal.module.less';
import { Button } from '../Button/Button';
export var ModalButtonID;
(function (ModalButtonID) {
    ModalButtonID["Cancel"] = "cancel";
    ModalButtonID["Ok"] = "ok";
})(ModalButtonID || (ModalButtonID = {}));
export function Modal({ children, buttons = [], onClose = () => { }, show = true, options }) {
    const opts = Object.assign({ cancelOnEsc: true, okOnEnter: true, x: false }, options ?? {});
    const rootRef = useRef(null);
    useEffect(() => {
        const keys = (e) => {
            if (e.key == 'Escape' && buttons.some(({ id }) => id == ModalButtonID.Cancel)) {
                if (opts.cancelOnEsc) {
                    e.preventDefault();
                    e.stopPropagation();
                    onClose(ModalButtonID.Cancel);
                }
            }
            if (e.key == 'Enter' && buttons.some(({ id }) => id == ModalButtonID.Ok)) {
                if (opts.okOnEnter) {
                    const b = buttons.find(({ id }) => id == ModalButtonID.Ok);
                    if (b?.disabled !== true) {
                        e.preventDefault();
                        e.stopPropagation();
                        onClose(ModalButtonID.Ok);
                    }
                }
            }
        };
        document.addEventListener('keydown', keys);
        return () => document.removeEventListener('keydown', keys);
    }, [buttons]);
    useEffect(() => {
        const active = document.activeElement;
        rootRef.current?.focus();
        return () => active?.focus?.();
    }, []);
    return (React.createElement(React.Fragment, null, show && createPortal(React.createElement("div", { ref: rootRef, className: styles.overlay, tabIndex: 1 },
        React.createElement("div", { className: styles.dialog },
            opts.x && buttons.some(({ id }) => id == ModalButtonID.Cancel) &&
                React.createElement("button", { className: styles.close, onClick: () => onClose(ModalButtonID.Cancel) }, "\u2715"),
            children,
            buttons.length > 0 &&
                React.createElement("footer", null, buttons.map(({ id, label, disabled }) => React.createElement(Button, { key: id, onClick: () => onClose(id), primary: id == 'ok', disabled: disabled ?? false }, label))))), document.body)));
}
